var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar'),_c('v-main',{staticClass:"app-main"},[_c('div',{staticClass:"main-container"},[_c('router-view',{key:_vm.$route.path})],1)]),_c('Footer'),_c('CarnivalPromoPopup',{model:{value:(_vm.showCarnivalPromo),callback:function ($$v) {_vm.showCarnivalPromo=$$v},expression:"showCarnivalPromo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }